var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBibliography(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7787 11.8745C42.7857 11.8745 24.0376 11.8745 23 11.8745V42.3781H43.7787C44.2899 42.3781 44.7043 41.9637 44.7043 41.4525V12.8001C44.7042 12.2889 44.2898 11.8745 43.7787 11.8745Z",
    fill: "#D6694B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 42.3781H0.92557C0.414359 42.3781 0 41.9636 0 41.4525V12.8001C0 12.2889 0.414359 11.8745 0.92557 11.8745H23V42.3781Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 39.3078H3.84099C3.43202 39.3078 3.10059 38.9763 3.10059 38.5674V10.5351C3.10059 10.1261 3.43211 9.79468 3.84099 9.79468H20.9637C22.0883 9.79468 22.9999 10.7063 22.9999 11.8309V39.3078Z",
    fill: "#F8E883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0483 9.79468C40.0881 9.79468 25.9196 9.79468 25.0362 9.79468C23.9116 9.79468 23 10.7063 23 11.8309V39.3078H41.0484C41.4573 39.3077 41.7888 38.9763 41.7888 38.5674V10.5351C41.7888 10.1262 41.4572 9.79468 41.0483 9.79468Z",
    fill: "#FFF3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6925 15.547H6.53862C6.15516 15.547 5.84448 15.2362 5.84448 14.8528C5.84448 14.4695 6.15525 14.1587 6.53862 14.1587H19.6925C20.076 14.1587 20.3867 14.4695 20.3867 14.8528C20.3867 15.2362 20.076 15.547 19.6925 15.547Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6925 20.2398H6.53862C6.15516 20.2398 5.84448 19.9291 5.84448 19.5457C5.84448 19.1623 6.15525 18.8516 6.53862 18.8516H19.6925C20.076 18.8516 20.3867 19.1623 20.3867 19.5457C20.3867 19.9291 20.076 20.2398 19.6925 20.2398Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6925 24.9329H6.53862C6.15516 24.9329 5.84448 24.6222 5.84448 24.2388C5.84448 23.8554 6.15525 23.5447 6.53862 23.5447H19.6925C20.076 23.5447 20.3867 23.8554 20.3867 24.2388C20.3867 24.6222 20.076 24.9329 19.6925 24.9329Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6925 29.9381H6.53862C6.15516 29.9381 5.84448 29.6273 5.84448 29.2439C5.84448 28.8605 6.15525 28.5498 6.53862 28.5498H19.6925C20.076 28.5498 20.3867 28.8606 20.3867 29.2439C20.3867 29.6273 20.076 29.9381 19.6925 29.9381Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7982 34.9437H26.9351C26.5516 34.9437 26.241 34.6329 26.241 34.2496C26.241 33.8662 26.5517 33.5554 26.9351 33.5554H39.7982C40.1817 33.5554 40.4923 33.8662 40.4923 34.2496C40.4923 34.6329 40.1816 34.9437 39.7982 34.9437Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6925 34.9437H6.53862C6.15516 34.9437 5.84448 34.6329 5.84448 34.2496C5.84448 33.8662 6.15525 33.5554 6.53862 33.5554H19.6925C20.076 33.5554 20.3867 33.8662 20.3867 34.2496C20.3867 34.6329 20.076 34.9437 19.6925 34.9437Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9624 15.547H26.9351C26.5516 15.547 26.241 15.2362 26.241 14.8528C26.241 14.4695 26.5517 14.1587 26.9351 14.1587H39.9624C40.3459 14.1587 40.6566 14.4695 40.6566 14.8528C40.6566 15.2362 40.3458 15.547 39.9624 15.547Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9624 20.2398H26.9351C26.5516 20.2398 26.241 19.9291 26.241 19.5457C26.241 19.1623 26.5517 18.8516 26.9351 18.8516H39.9624C40.3459 18.8516 40.6566 19.1623 40.6566 19.5457C40.6566 19.9291 40.3458 20.2398 39.9624 20.2398Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9624 24.9325H26.9351C26.5516 24.9325 26.241 24.6217 26.241 24.2383C26.241 23.855 26.5517 23.5442 26.9351 23.5442H39.9624C40.3459 23.5442 40.6566 23.855 40.6566 24.2383C40.6566 24.6217 40.3458 24.9325 39.9624 24.9325Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7982 29.9381H26.9351C26.5516 29.9381 26.241 29.6273 26.241 29.2439C26.241 28.8605 26.5517 28.5498 26.9351 28.5498H39.7982C40.1817 28.5498 40.4923 28.8606 40.4923 29.2439C40.4923 29.6273 40.1816 29.9381 39.7982 29.9381Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0745 11.8745H43.2234C43.7346 11.8745 44.149 12.2889 44.149 12.8001V41.4525C44.149 41.9637 43.7346 42.3781 43.2234 42.3781H45.0745C45.5857 42.3781 46.0001 41.9637 46.0001 41.4525V12.8001C46.0001 12.2889 45.5857 11.8745 45.0745 11.8745Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.159 9.79468H40.3079C40.7168 9.79468 41.0483 10.1262 41.0483 10.5351V38.5674C41.0483 38.9764 40.7167 39.3078 40.3079 39.3078H42.159C42.568 39.3078 42.8994 38.9763 42.8994 38.5674V10.5351C42.8995 10.1262 42.568 9.79468 42.159 9.79468Z",
    fill: "#F8E883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5032 6.96803V3.88082C34.5032 3.73797 34.3874 3.62207 34.2445 3.62207C33.2775 3.62207 33.5945 3.62207 32.6525 3.62207C32.5097 3.62207 32.3938 3.73788 32.3938 3.88082V6.96803H34.5032Z",
    fill: "#8D9CA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2445 3.62207C33.466 3.62207 33.5194 3.62207 33.0784 3.62207C33.2213 3.62207 33.3371 3.73788 33.3371 3.88082V6.96803H34.5033V3.88082C34.5033 3.73797 34.3875 3.62207 34.2445 3.62207Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2488 24.5661V10.9546H31.7407V27.0109H34.2488V26.757V24.5661Z",
    fill: "#3692BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7407 6.96802H34.2488V10.9546H31.7407V6.96802Z",
    fill: "#6CABCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 6.96802H35.1565V10.9546H33.7959V6.96802Z",
    fill: "#3692BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 10.9546V24.5661V26.7569V27.0109H34.8637H35.1565V26.757V10.9546H33.7959Z",
    fill: "#0681AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3237 29.2569L34.3512 27.011C33.7661 27.011 32.2739 27.011 31.7407 27.011L32.7683 29.2569H33.3237Z",
    fill: "#B6C4CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 27.0108L32.7683 29.2567L33.142 30.0733C33.2621 30.336 33.6352 30.336 33.7553 30.0733L35.1565 27.0107H33.7959V27.0108Z",
    fill: "#9FACBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.159 9.79468H40.3079C40.7168 9.79468 41.0483 10.1262 41.0483 10.5351V38.5674C41.0483 38.9764 40.7167 39.3078 40.3079 39.3078H42.159C42.568 39.3078 42.8994 38.9763 42.8994 38.5674V10.5351C42.8995 10.1262 42.568 9.79468 42.159 9.79468Z",
    fill: "#F8E883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8145 15.547C37.4311 15.547 37.1204 15.2362 37.1204 14.8528V7.85679C37.1204 7.74943 37.0331 7.66219 36.9257 7.66219H31.741C31.3576 7.66219 31.0469 7.35142 31.0469 6.96806C31.0469 6.5847 31.3576 6.27393 31.741 6.27393H36.9257C37.7985 6.27393 38.5088 6.98405 38.5088 7.85688V14.8528C38.5088 15.2361 38.198 15.547 37.8145 15.547Z",
    fill: "#596C76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBibliography);
export default __webpack_public_path__ + "static/media/bibliography.e58e4d26e8b207853c5ba86256c47256.svg";
export { ForwardRef as ReactComponent };